// extracted by mini-css-extract-plugin
export default {"noProducts":"ProductRecommendationsStep_noProducts__VcpRH","phoneNumber":"ProductRecommendationsStep_phoneNumber__1ZeFm","wrapper":"ProductRecommendationsStep_wrapper__2txtC"};